<template>
  <div class="container-success">
    <div class="box-message">
      <h1>Transaction status</h1>
      <div class="box-intern">
        <h4>Invoice: #{{invoiceNumber}}</h4>
        <h4>Transaction reference: {{data}}</h4>
        <h4>Transaction date: {{transactionDate | filterDate}}</h4>
        <h4>Transaction time: {{transactionTime |filterTime}}</h4>
        <h4>Amount: {{ amount }}</h4>
      </div>
      <span>Successful transaction</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'success-payment',
  data() {
    return {
      data: '',
      amount: localStorage.getItem('amount'),
      invoiceNumber: localStorage.getItem('invoice_number'),
      transactionDate: localStorage.getItem('updated_at'),
      transactionTime: localStorage.getItem('updated_at'),
    };
  },
  mounted() {
    this.data = this.$route.params.reference;
  },
};
</script>
<style lang="scss" scoped>
.container-success {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-image: url("../../src/assets/background/background-pay.svg");
  background-size: cover;
  .box-message {
    padding: 25px;
    min-width: 35vw;
    min-height: 50vh;
    background-color: $white;
    border-radius: 10px;
    h1 {
      font-size: 36px;
      color: $header;
      margin-bottom: 10px;
      text-align: left;
      word-break: break-word;
    }
    .box-intern {
      margin: 0 auto;
      color: $black;
      h4 {
        text-align: left;
        margin-bottom: 10px;
      }
    }
    span {
      padding: 0.5rem 1rem;
      font-size: 24px;
      color: $payed;
      border-radius: 96px;
      font-weight: 600;
    }
  }
}
</style>
